var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #ef4e3e;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0C19.89,15.75,15.75,19.89,0,25c15.75,5.11,19.89,9.25,25,25,5.11-15.75,9.25-19.89,25-25C34.25,19.89,30.11,15.75,25,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurst);
export default __webpack_public_path__ + "static/media/burst.6937035ea74b01e16af64fd9e269acbc.svg";
export { ForwardRef as ReactComponent };